<template>
  <section class="cn-user-help-cards">
    <div class="container">
      <div class="cn-user-help-cards__content">
        <component
          :is="card.serviceForm ? 'button' : UiLink"
          v-for="(card, i) in data?.items ?? []"
          :key="i"
          :to="!card.serviceForm ? card.url : undefined"
          type="button"
          class="cn-user-help-cards__card"
          v-on="card.serviceForm ? { click: showServiceForm } : {}"
        >
          <div class="cn-user-help-cards__card-inner">
            <div class="cn-user-help-cards__card-content">
              <CdnImg :src="card.image" :width="100" :height="100" />
              <div>
                <h2 class="cn-user-help-cards__card-title">{{ card.title }}</h2>
                <p class="cn-user-help-cards__card-description">
                  {{ card.description }}
                </p>
              </div>
            </div>
          </div>
        </component>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import UiLink from '@/components/ui/UiLink';

interface Props {
  data: {
    items: {
      url?: string | null;
      image: string;
      title: string;
      description: string;
      serviceForm?: boolean | null;
    }[];
  };
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'show-service-form'): void;
}>();

function showServiceForm() {
  emit('show-service-form');
}
</script>

<style lang="scss">
.cn-user-help-cards {
  --ab-canyon-user-help-cards-card-inner-color-border: var(
    --ab-canyon-color-neutral
  );
  --ab-canyon-user-help-cards-card-inner-color-bg-hover: var(
    --ab-canyon-color-neutral-light
  );
  --ab-canyon-user-help-cards-card-description-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  &__content {
    padding-top: var(--size-3xl);
    padding-bottom: var(--size-3xl);
    gap: var(--size-xl);
    grid-template-columns: repeat(1, minmax(0, 1fr));
    display: grid;
    @media (min-width: 656px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (min-width: 1280px) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  &__card-inner {
    border-color: var(--ab-canyon-user-help-cards-card-inner-color-border);

    transition-duration: 500ms;
    transition-property: border-color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    padding: var(--size-3xl);
    border-width: 1px;
    height: 100%;
    &:hover {
      background-color: var(
        --ab-canyon-user-help-cards-card-inner-color-bg-hover
      );
    }
  }
  &__card-content {
    row-gap: var(--size-lg);
    align-items: center;
    flex-direction: column;
    display: flex;
  }
  &__card-title {
    text-align: center;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 700;
    color: var(--ab-canyon-user-help-cards-card-description-color-text);
  }
  &__card-description {
    color: var(--ab-canyon-user-help-cards-card-description-color-text);
    text-align: center;
  }
}
</style>
